module.exports = __webpack_public_path__ + "img/sp-title.beb75da0.png";